import { render, staticRenderFns } from "./IconComponentWBots.vue?vue&type=template&id=bd65d38a&"
import script from "./IconComponentWBots.vue?vue&type=script&lang=js&"
export * from "./IconComponentWBots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports